import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PrecisionTab from '@components/common/Dashboard/DashboardTabs/PrecisionTab';
import { MoreDropDown } from '@components/common';
import { Button, Switch } from 'antd';
import { PRECISION_POLICY_PATH, CHANGE_LOG_PATH } from '@utils/constants';
import { precisionPolicySchedulingFeatureSelector } from '@store/common/selectors';
import { ViewTypes } from '@store/policies/precisionPolicy/reducers';
import { ButtonsWrapper, StyledTabs, ActionsWrapper } from './styled';
import ScheduleModal from '../ScheduleModal';
import { ViewAllSchedulesButton } from '../ScheduleList';
import { VerticalAlignMiddleOutlined } from '@ant-design/icons';
import { toggleExpandedView } from '@store/policies/precisionPolicy/actions';
import { isExpandedViewSelector } from '@store/policies/precisionPolicy/selectors';

interface IProps {
  editMode: boolean;
  onCancel: () => void;
  onOk: () => void;
  onToggle: () => void;
  canEdit?: boolean;
  activeView: ViewTypes;
}

const Buttons: React.FC<IProps> = ({
  editMode,
  onCancel,
  onOk,
  onToggle,
  canEdit = false,
  activeView,
}) => {
  const schedulingFeatureFlag = useSelector(precisionPolicySchedulingFeatureSelector);
  const isExpandedView = useSelector(isExpandedViewSelector);
  const dispatch = useDispatch();

  const getReorderButton = () =>
    canEdit && (
      <Button onClick={onToggle} icon={<VerticalAlignMiddleOutlined />}>
        Re-order Policies
      </Button>
    );

  const createMenuItems = () => [
    {
      key: 'change-log',
      label: (
        <Link to={`${CHANGE_LOG_PATH}?type=precision_policy&back=${PRECISION_POLICY_PATH}`}>
          Change Log
        </Link>
      ),
    },
  ];

  const getKebabMenuOptions = () =>
    activeView === ViewTypes.policies && <MoreDropDown menu={{ items: createMenuItems() }} />;

  const getExpandedViewToggle = () => (
    <>
      {'Expanded View'}
      <Switch checked={isExpandedView} onChange={onClickOfToggle} />
    </>
  );

  const getPrimaryButtons = () =>
    schedulingFeatureFlag && (
      <>
        <div style={{ borderLeft: 'solid #d9d9d9 2px', height: '100%', padding: '0px 2px' }} />
        <ViewAllSchedulesButton />
        <ScheduleModal canEdit={canEdit} />
        {getReorderButton()}
      </>
    );

  const getEditModeOptions = () => (
    <div>
      <Button onClick={onCancel} key="cancel">
        Cancel Changes
      </Button>
      <Button type="primary" onClick={onOk} key="save">
        Save Changes
      </Button>
    </div>
  );

  const onClickOfToggle = () => {
    dispatch(toggleExpandedView());
  };

  const getActionButtons = () => {
    if (editMode) {
      return (
        <ActionsWrapper>
          {getExpandedViewToggle()}
          {getEditModeOptions()}
        </ActionsWrapper>
      );
    } else {
      return (
        <ActionsWrapper>
          {getExpandedViewToggle()}
          {getPrimaryButtons()}
          {getKebabMenuOptions()}
        </ActionsWrapper>
      );
    }
  };

  return (
    <ButtonsWrapper>
      <StyledTabs>
        <PrecisionTab />
      </StyledTabs>
      {activeView !== ViewTypes.schedules && getActionButtons()}
    </ButtonsWrapper>
  );
};

export default React.memo(Buttons);
